import React, { Component } from 'react';
import { Button, Calendar, Icon } from 'antd';
import HighSearchInput from '../../common/HighSearchInput';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';
import SearchRetrieve from '../../common/SearchRetrieve.new';
import SelectProvince from '../../common/SelectProvince';

const monthFormat = 'YYYY-MM';
const dateFormat = 'YYYY-MM-DD';

class ECalendar extends Component {
    state = {
        date: moment().format(dateFormat),
    }

    componentDidMount() {
        this.triggerChange();
    }

    dateCellRender = value => {
        const { redList } = this.props;
        const hasRed = redList.some(i => moment(i).format(dateFormat) == moment(value).format(dateFormat));
        if (hasRed) {
            return <i className="redPoint">●</i>;
        }
    }

    handleDateSelect = (value) => {
        this.setState({
            date: moment(value).format(dateFormat),
        }, () => {
            this.triggerChange();
        });
    }

    changeMonth = (type) => {
        const { date } = this.state;
        const curdate = type == 'prev' ? moment(date).subtract(1, 'months').format(dateFormat) : moment(date).add(1, 'months').format(dateFormat);
        this.setState({
            date: curdate,
        }, () => {
            this.triggerChange();
        });
    }

    triggerChange = () => {
        const { date } = this.state;
        this.props.onSelect(date);
    }

    
    render() {
        const { date } = this.state;
        return (
            <div className="home-cal" style={{ width: '100%', borderRadius: 4 }}>
                <a onClick={() => this.changeMonth('prev')} className="leftChangeMonth">
                    <Icon type="left-circle-o" />
                </a>
                <a onClick={() => this.changeMonth('next')} className="RightChangeMonth" >
                    <Icon type="right-circle-o" />
                </a>
                <Calendar
                    mode="month"
                    fullscreen={false}
                    onPanelChange={this.handleDateSelect}
                    onSelect={this.handleDateSelect}
                    dateCellRender={this.dateCellRender}
                    value={moment(date)}
                />
            </div>
        );
    }
}

class LeaveSituation extends Component {
    state = {
        data: [],
        redList: [],
        searchParams: {},
        areaParams: {},
        calendarDate: moment().format(dateFormat),
    }

    loadRemindPoint = () => {
        const { calendarDate, searchParams, areaParams } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.home.queryUserVacationDate,
            data: {
                date: moment(calendarDate).format(monthFormat),
                ...searchParams,
                ...areaParams,
                hasCheckedArea: undefined,
            },
            dataType: 'json',
            doneResult: res => {
                const { data: { dates }} = res;
                this.setState({
                    redList: dates,
                });
            }
        };
        $.sendRequest(options);
    }

    loadData = () => {
        const { calendarDate, searchParams, areaParams } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.home.queryUserVacation,
            data: {
                date: moment(calendarDate).format(dateFormat),
                ...searchParams,
                ...areaParams,
                hasCheckedArea: undefined,
            },
            dataType: 'json',
            doneResult: res => {
                const { data } = res.data;
                this.setState({ data });
            }
        };
        $.sendRequest(options);
    }

    onSelect = (calendarDate) => {
        this.setState({
            calendarDate,
        }, () => {
            this.search();
        });
    }

    handleChange = (option, key) => {
        const { searchParams } = this.state;
        searchParams[`${key}Id`] = option.value; 
        searchParams[`${key}Name`] = option.text; 
        this.setState({
            searchParams,
        });
    }

    search = () => {
        this.loadRemindPoint();
        this.loadData();
    }

    saveProvince = (checkedArea) => {
        const areaParams = {};
        checkedArea.map(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        const hasCheckedArea = checkedArea.map(item => item.key);
        this.setState({
            areaParams: {
                ...areaParams,
                hasCheckedArea,
                areaName: areaList.join(','),
            }
        });
    }

    render() {
        const { redList, data, searchParams, areaName, hasCheckedArea = [] } = this.state;
        return (
            <div className='flexItem outer'>
                <div className="modTitle">休假情况</div>
                <div style={{ color: 'red' }}>本页面展示的项目组成员已提交的休假申请，请及时与休假人员或主管确认工作安排</div>
                <div className="flexBox">
                    <div className='side flexItem'>
                        <SearchRetrieve
                            keyword='hospitalName'
                            style={{ width: 165, margin: '8px 20px 0 0' }}
                            placeholder="中心名称"
                            value={searchParams.hospitalName}
                            params={{ limit: 20 }}
                            url={API_URL.hospital.hospitalList}
                            config={{ id: 'hospitalId', name: 'hospitalName' }}
                            onChange={value => this.handleChange(value, 'hospital')}
                        />
                        <SearchRetrieve
                            keyword='investigationName'
                            style={{ width: 165, margin: '8px 20px 0 0' }}
                            placeholder="输入项目名称检索"
                            value={searchParams.investigationName}
                            params={{ limit: 20 }}
                            url={API_URL.investigation.queryInvestigationByName}
                            config={{ id: 'investigationId', name: 'investigationName' }}
                            onChange={(option) => this.handleChange(option, 'investigation')}
                        />
                        <SelectProvince 
                            style={{ width: 165, margin: '8px 20px 0 0' }}
                            areaName={areaName} 
                            saveProvince={this.saveProvince} 
                            hasCheckedArea={hasCheckedArea} 
                        />
                        <SearchRetrieve
                            keyword='keyword'
                            style={{ width: 165, margin: '8px 20px 0 0' }}
                            value={searchParams.leaderUserName}
                            params={{ limit: 20, dimissionStatus: 'WORKING' }}
                            placeholder="输入主管领导姓名/工号检索"
                            url={API_URL.investigation.queryUserByKey}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={option => this.handleChange(option, 'leaderUser')}
                        />
                        <Button 
                            type="primary" 
                            onClick={()=>this.search()}
                        >统计</Button>
                        <div className='bgwhite Seance' style={{ marginTop: 8, marginBottom: 20 }}>
                            <ECalendar redList={redList} onSelect={this.onSelect} />
                        </div>
                    </div>
                    <div className='flexItem'>
                        <div style={{ marginTop: 8, paddingLeft: 4, lineHeight: '28px', fontWeight: 'bold', background: '#f1f1f1' }}>
                            {'项目成员休假情况'}
                        </div>
                        <ul style={{ height: 480, overflowX: 'hidden', overflowY: 'auto' }}>
                            { data.map(el => <li 
                                    key={el.vacationDataId} 
                                    style={{ padding: '6px 10px', 
                                    borderBottom: '1px solid #ccc' }}
                                >
                                    {
                                        `${el.name}[${el.badge}]于${el.beginTime}至${el.endTime}休假（工作城市/驻外城市：${el.workCityName}，主管领导：${el.leaderUserCompellation}[${el.leaderEmployeeCode}]）`
                                    }
                                </li>) 
                            }
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default LeaveSituation;


// WEBPACK FOOTER //
// ./src/components/homePage/afficheNews/LeaveSituation.js